export const GoalTypes = {
    CONTRACT: "contract",
    ERP: "ERP"
}

export const BillingTypes = {
    MONTHLY: { value: 'monthly', label: '월간', disabled: false },
    YEARLY: { value: 'yearly', label: '연간', disabled: false },
    ONE_TIME: { value: 'oneTime', label: '일회성', disabled: false },
    PER_CASE: { value: 'perCase', label: '건당', disabled: true }
}

// 과금 방식에 따른 사용료 라벨
export const getUsageFeeLabel = (billingType) => {
    switch (billingType) {
        case 'monthly':
            return '월 사용료(VAT포함)';
        case 'yearly':
            return '연간 사용료(VAT포함)';
        case 'oneTime':
        default:
            return '사용료(VAT포함)';
    }
}

// 과금 방식 value로 label 조회
export const getBillingTypeLabel = (value) => {
    const found = Object.values(BillingTypes).find(bt => bt.value === value);
    return found ? found.label : value;
}